import React, { Component } from 'react';
import './App.css';
import Tilt from 'react-tilt';

class App extends Component {
  render() {
    return (
      <div className='size1 bg0 where1-parent'>
        <div
          className='flex-c-m bg-img1 size2 where1 overlay1 where2 respon2'
          style={{ backgroundImage: "url('images/bg-1.jpg')" }}
        >
          <Tilt className='Tilt' options={{ max: 50 }}>
            <div className='Tilt-inner'>
              {' '}
              <div className='wsize2 flex-w flex-c-m cd100 js-tilt'>
                <div className='flex-col-c-m size6 bor2 m-l-10 m-r-10 m-t-15'>
                  <span className='l2-txt1 p-b-9'>adventure</span>
                </div>
                <div className='flex-col-c-m size6 bor2 m-l-10 m-r-10 m-t-15'>
                  <span className='l2-txt1 p-b-9'>travel</span>
                </div>
                <div className='flex-col-c-m size6 bor2 m-l-10 m-r-10 m-t-15'>
                  <span className='l2-txt1 p-b-9'>adrenaline</span>
                </div>
              </div>{' '}
            </div>
          </Tilt>
        </div>

        <div className='size3 flex-col-sb flex-w p-l-75 p-r-75 p-t-45 p-b-45 respon1'>
          <div className='wrap-pic1'>
            <img src='images/icons/logo.png' alt='LOGO' />
          </div>

          <div className='p-t-50 p-b-60'>
            <p className='m1-txt1 p-b-36'>
              A team committed to provide you with best{' '}
              <span className='m1-txt2'>personalized experiences</span>
            </p>
            <p className='m1-txt1 p-b-10' style={{ fontSize: '18px' }}>
              Contact us for an adventure!
            </p>
            <p className='s2-txt3'>
              <b style={{ marginRight: '5px' }}>Contact Number: </b> +92 310
              9876000
            </p>
            <p className='s2-txt3'>
              <b style={{ marginRight: '5px' }}>Email Address: </b>{' '}
              <a
                href='mailto:hello@adraveline.com'
                style={{ color: '#F08000' }}
              >
                hello@adraveline.com
              </a>
            </p>
          </div>

          <div className='flex-w'>
            <a
              href='https://www.facebook.com/adraveline/'
              target='popup'
              className='flex-c-m size5 bg3 how1 trans-04 m-r-5'
            >
              <i
                className='fa fa-facebook'
                style={{ textDecoration: 'none' }}
              ></i>
            </a>
            <a
              href='https://www.instagram.com/adraveline/'
              target='popup'
              className='flex-c-m size5 bg3 how1 trans-04 m-r-5'
            >
              <i className='fa fa-instagram'></i>
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js